import { Form, Notice } from '@/shared/ui'

export const RecommenderPhoneNumber = () => {
  return (
    <>
      <Form.Field name="recommenderPhoneNumber">
        <Form.Label bold optional className="text-black">
          추천인 휴대폰 번호
        </Form.Label>
        <Form.TextField
          type="tel"
          placeholder="추천인 휴대폰 번호를 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>
      <Notice.Title className="mt-6">유의사항</Notice.Title>
      <Notice.List gap={false} className="text-gray-800 *:before:bg-gray-800">
        <Notice.Item>{`추천인 휴대폰 번호는 가입 후 변경하거나 추가할 수\n없으니 정확한 정보를 입력해 주세요.`}</Notice.Item>
      </Notice.List>
    </>
  )
}
